import angular, { ICompileService, IScope, ITimeoutService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  IGridSettings,
  NullGridSettings,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import { OptionsFilter } from "../../../records/grids/columns/filters/subFilters/OptionsFilter";
export class SelectPartQuantityModalController {
  static $inject = [
    "$uibModalInstance",
    ServerUtilityName,
    ColumnDefinitionServiceName,
    "$timeout",
    "$compile",
    "$scope",
  ];

  readonly datasource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];

  constructor(
    readonly $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
    serverUtility: ServerUtility,
    columnDefinitionService: ColumnDefinitionService,
    $timeout: ITimeoutService,
    $compile: ICompileService,
    private readonly $scope: IScope
  ) {
    $timeout(() => {
      const modalContent = document.querySelector(".modal-content");
      if (modalContent) {
        const modalWindow = angular.element(modalContent);
        modalWindow.css("width", 1100);
      }
    }, 0);

    this.gridSettings = new NullGridSettings();
    this.datasource = new RecordDataSource(
      serverUtility,
      "/api/parts/locations"
    );

    $scope.$on("partQuantitySelected", (event, partQuantity) => {
      event.preventDefault();
      this.partQuantitySelected(partQuantity);
    });

    this.columns = [
      {
        headerName: "",
        width: 20,
        editable: false,
        suppressMenu: true,
        suppressSorting: true,
        template: `<i class="fa fa-plus-circle text-primary" ng-click="$emit('partQuantitySelected', data)"></i>`,
      },
      columnDefinitionService.getNumberColDef({
        field: "PartLocationId",
        hide: true,
        header: "Id",
      }),
      columnDefinitionService.getStringColDef({
        field: "PartPropertyName",
        header: "Room",
      }),
      columnDefinitionService.getStringColDef({
        field: "Shelf",
      }),
      columnDefinitionService.getStringColDef({
        field: "Bin",
        header: "Bin",
      }),
      columnDefinitionService.getStringColDef({
        field: "PartManufacturerName",
        header: "Manufacturer",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "PartNumber",
      }),
      columnDefinitionService.getStringColDef({
        field: "PartDescription",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Quantity",
      }),
      columnDefinitionService.getStringColDef({
        field: "PartKeywordName",
        header: "Keyword",
        hide: true,
      }),
      {
        field: "Status",
        headerName: "Status",
        filter: new FilterProvider("Status", $compile)
          .addFilter(
            "=",
            new OptionsFilter({
              displayName: "=",
              options: [
                { display: "Active", value: "Active" },
                { display: "Inactive", value: "Inactive" },
              ],
              queryFieldNames: ["Status"],
              includeNullValue: true,
            })
          )
          .getGridFilterFactory(),
        hide: true,
      },
      columnDefinitionService.getBooleanColDef({
        field: "TrackedItem",
        hide: true,
      }),
    ];
  }

  partQuantitySelected(partQuantity: any) {
    (<any>this.$scope).$resolve.options.partQuantitySelected(partQuantity);
  }
}
